import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import QRCode from "react-qr-code";
import {
  Card,
  CardBody,
  CardText,
  CardFooter,
  CardGroup,
  CardHeader,
  Button,
  Container,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import qrDesign from "../../../src/assets/qr.png";
import tag from "../../../src/assets/images/tag.svg";

const Pass = ({ name, price, duration, address, createdAt, filter, code }) => {
  const discount = 0.9;
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 576);
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Card
      style={{
        width: "100%",
        maxWidth: "360px",
        height: "200px",
        padding: "20px",
        borderRadius: "16px",
        backgroundImage: `url(${filter})`,
        objectFit: "cover",
        position: "relative",
        marginBottom: "10px",
      }}
    >
      {/* Card content */}

      <div
        style={{
          position: "absolute",
          top: "16px",
          left: "16px",
          padding: "5px 10px",
          backgroundColor: "white",
          borderRadius: "80px",
          fontSize: "12px",
          fontWeight: "normal",
        }}
        className="ff-sora secondary-black"
      >
        {duration === "oneday"
          ? "1 Day Pass"
          : duration === "oneweek"
          ? "1 Week Pass"
          : duration === "onemonth"
          ? "1 Month Pass"
          : null}
      </div>

      <div
        style={{
          position: "absolute",
          top: "-10px",
          right: "13px",
        }}
        className="primary-black fw-bold font-size-14 ff-sora"
      >
        <img
          src={tag}
          alt={"passDesign"}
          className="icon-image"
          style={{
            position: "absolute",
            right: "0px",
            top: "0px",
          }}
        />
      </div>
      {/* <del
        style={{
          position: "absolute",
          bottom: "16px",
          right: "182px",
        }}
        className="primary-black fw-bold font-size-14 ff-sora"
      >
        {parseFloat(coinsPrice) <= 1
          ? `${parseFloat(coinsPrice)}`
          : `${parseFloat(coinsPrice)}`}
      </del> */}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          right: "20px",
        }}
        className="primary-black fw-medium font-size-14 ff-sora"
      >
        <h2 className="ff-sora m-0 font-size-12 text-end fw-normal secondary-black">
          Created At:
        </h2>
        <p className="ff-sora font-size-14 fw-normal primary-black">
          {createdAt ? new Date(createdAt).toLocaleDateString() : "01/01/2025"}
        </p>
      </div>
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <h2
            style={{ margin: "40px 0 0px" }}
            className="ff-sora font-size-20 fw-normal primary-black"
          >
            {(() => {
              const wordLimit = 3;
              const charLimit = isSmallScreen ? 15 : 20;
              const words = name?.split(" ") || [];
              let sliced = words?.slice(0, wordLimit)?.join(" ");
              if (sliced?.length > charLimit) {
                sliced = sliced?.substring(0, charLimit);
              }
              return (
                sliced +
                (words?.length > wordLimit || name?.length > charLimit
                  ? "..."
                  : "")
              );
            })()}
          </h2>
          <p className="ff-sora font-size-14 fw-normal text-capitalize secondary-black">
            {address?.split(" ").slice(0, 2).join(" ")}
            <br />
            {address?.split(" ").slice(2).join(" ")}
          </p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          borderRadius: "4px",
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: "-5px",
            left: "20px",
          }}
        >
          <h2 className="ff-sora m-0 font-size-12 fw-normal secondary-black">
            Pass Amount:
          </h2>
          <p className="ff-sora font-size-14 fw-normal primary-black">
            {parseFloat(price * discount) <= 1
              ? `Coin ${formatNumber(parseFloat(price * discount))} `
              : `Coins ${formatNumber(parseFloat(price * discount))} `}
            <del className="light-black">{formatNumber(parseFloat(price))}</del>
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            right: "20px",
            bottom: "62px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "63px",
          }}
        >
          {/* <p
            className="font-size-10 ff-sora"
            style={{
              writingMode: "sideways-lr",
              textOrientation: "sideways",
              whiteSpace: "nowrap",
              marginRight: "-1px",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            Taha
          </p> */}
          <div
            style={{
              height: "auto",
              margin: "0 auto",
              maxWidth: 64,
              width: "100%",
            }}
          >
            <QRCode
              size={256}
              style={{
                height: "auto",
                maxWidth: "100%",
                width: "100%",

                width: "63px",
              }}
              value={code}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

Pass.propTypes = {};

export default Pass;
